//CRN_20260205 - TopbarComponent now displays error messages

import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParams, CookieKeys, StorageValues, TypeProgressInformation } from 'src/app/core/consts';
import { AddTicketNoteModalFormComponent } from 'src/app/forms-modal/_tickets/add-ticket-note-modal-form/add-ticket-note-modal-form.component';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { allNotification, messages } from './data'
import { AuthenticationService } from '../../core/services/auth.service';
import { AutoLogoutService } from 'src/app/core/services/utelize/general/auto-logout-service';
import { cartData } from './data';
import { CartModel } from './topbar.model';
import { catchError, finalize, firstValueFrom, forkJoin, map, of, Subscription, switchMap, throwError } from 'rxjs';
import { ChatGptAction, ChatGptModalTarget } from 'src/app/core/types/chatgpt/types-chatgpt';
import { ChatGptModalFormComponent } from 'src/app/forms-modal/_ai/chat-gpt-modal-form/chat-gpt-modal-form.component';
import { ChatGptService } from 'src/app/core/services/utelize/general/chatgpt-service';
import { ClockService } from 'src/app/core/services/utelize/general/clock-service';
import { CommunicationGridModalFormComponent } from 'src/app/forms-modal/_communication/communication-grid-modal-form/communication-grid-modal-form.component';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyModalFormComponent } from 'src/app/forms-modal/_company/company-modal-form/company-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptAesClientSide, EncryptAesClientSide } from 'src/app/core/encryption';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { DOCUMENT } from '@angular/common';
import { DownloadCentreModalFormComponent } from 'src/app/forms-modal/_file-transfers/download-centre-modal-form/download-centre-modal-form.component';
import { DropdownService } from 'src/app/core/services/utelize/general/dropdown-service';
import { environment } from 'src/environments/environment';
import { eUser } from 'src/app/core/enums';
import { EventService } from '../../core/services/event.service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { ImagesModalFormComponent } from 'src/app/forms-modal/_pop-ups/images-modal-form/images-modal-form.component';
import { InformationModalFormComponent } from 'src/app/forms-modal/_pop-ups/information-modal-form/information-modal-form.component';
import { LanguageService } from '../../core/services/language.service';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { ProvisionModalFormComponent } from 'src/app/forms-modal/_provisioning/provision-modal-form/provision-modal-form.component';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/core/services/utelize/general/storage-service';
import Swal from 'sweetalert2';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { Ticket } from 'src/app/core/models/system/support/ticket-hub/ticket';
import { TicketModalFormComponent } from 'src/app/forms-modal/_tickets/ticket-modal-form/ticket-modal-form.component';
import { TimelineEsimModalFormComponent } from 'src/app/forms-modal/_time-line/timeline-esim-modal-form/timeline-esim-modal-form.component';
import { TopBarService } from 'src/app/core/services/utelize/general/top-bar-service';
import { UploadCentreModalFormComponent } from 'src/app/forms-modal/_file-transfers/upload-centre-modal-form/upload-centre-modal-form.component';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UserModalFormComponent } from 'src/app/forms-modal/_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

export class TopbarComponent implements AfterViewInit, OnDestroy, OnInit {

  @Output() mobileMenuButtonClicked=new EventEmitter();

  @ViewChild('chatGptModalForm',           { static: false }) chatGptModalForm!          : ChatGptModalFormComponent;
  @ViewChild('communicationGridModalForm', { static: false }) communicationGridModalForm!: CommunicationGridModalFormComponent;
  @ViewChild('companyModalForm',           { static: false }) companyModalForm!          : CompanyModalFormComponent;
  @ViewChild('downloadCentreForm',         { static: false }) downloadCentreForm!        : DownloadCentreModalFormComponent;
  @ViewChild('imageModalForm',             { static: false }) imageModalForm!            : ImagesModalFormComponent;
  @ViewChild('informationModalForm',       { static: false }) informationModalForm!      : InformationModalFormComponent;
  @ViewChild('manageEsimModalForm',        { static: false }) manageEsimModalForm!       : ManageEsimModalFormComponent;
  @ViewChild('progressInfoRow',            { static: false }) progressInfoRow?           : ElementRef<HTMLDivElement>;
  @ViewChild('provisionModalForm',         { static: false }) provisionModalForm!        : ProvisionModalFormComponent;
  @ViewChild('removenotification'                           ) removenotification!        : TemplateRef<any>;
  @ViewChild('ticketModalForm',            { static: false }) ticketModalForm!           : TicketModalFormComponent;
  @ViewChild('ticketNotesModalForm',       { static: false }) ticketNotesModalForm!      : AddTicketNoteModalFormComponent;
  @ViewChild('timelineModalForm',          { static: false }) timelineModalForm!         : TimelineEsimModalFormComponent;
  @ViewChild('tooltipAddCompany',                           ) tooltipAddCompany!         : NgbTooltip;
  @ViewChild('tooltipAddSim',                               ) tooltipAddSim!             : NgbTooltip;
  @ViewChild('tooltipAddSupportTicket',                     ) tooltipAddSupportTicket!   : NgbTooltip;
  @ViewChild('tooltipAddUserPortal',                        ) tooltipAddUserPortal!      : NgbTooltip;
  @ViewChild('tooltipAddUserSim',                           ) tooltipAddUserSim!         : NgbTooltip;
  @ViewChild('tooltipChatGpt',                              ) tooltipChatGpt!            : NgbTooltip;
  @ViewChild('tooltipDownloads',                            ) tooltipDownloads!          : NgbTooltip;
  @ViewChild('tooltipFullscreen',                           ) tooltipFullscreen!         : NgbTooltip;
  @ViewChild('tooltipSsoLogin',                             ) tooltipSsoLogin!           : NgbTooltip;
  @ViewChild('tooltipTimeline',                             ) tooltipTimeline!           : NgbTooltip;
  @ViewChild('tooltipToggleBtn',                            ) tooltipToggleBtn!          : NgbTooltip;
  @ViewChild('tooltipUploads',                              ) tooltipUploads!            : NgbTooltip;
  @ViewChild('topbarToggleBtn',            { static: false }) topbarToggleBtn?           : ElementRef<HTMLButtonElement>;
  @ViewChild('uploadCentreForm',           { static: false }) uploadCentreForm!          : UploadCentreModalFormComponent;
  @ViewChild('userModalForm',              { static: false }) userModalForm!             : UserModalFormComponent;

  get currentRouteUrl         () { return this.router.url                                                                 ; }
  get dashboardUrl            () { return this.componentAccessUserService.dashboardUrl                                    ; }
  get showAddCompanyIcon      () { return this.topBarService.showAddCompanyIcon                                           ; }
  get showAddSimIcon          () { return this.topBarService.showAddSimIcon                                               ; }
  get showAddSupportTicketIcon() { return this.topBarService.showAddSupportTicketIcon                                     ; }
  get showAddUserSimIcon      () { return this.topBarService.showAddUserSimIcon                                           ; }
  get showAddUserPortalIcon   () { return this.topBarService.showAddUserPortalIcon                                        ; }
  get showAssistant           () { return (this.topBarShowChatGpt && this.featureEnabledChatGpt)
                                          || this.showTemplateMenuItems                                                   ; }
  get showBackToPlatformInview() { return this.isPlatformModeInview && this.platformInviewService.getMode() !== 'platform'; }
  
  get showDemoModeToggle       () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.DemoShowDemoItems,         true ); }
  get topBarWorldClockHideFlags() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.TopBarWorldClockHideFlags, true ); }

  get chatGptAliasFull       () { return this.configSystemService.getValue(ConfigSystemParams.ChatGptAliasFull, ApplicationNames.ChatGPT)     ; }
  get showMobileMigrationIcon() { return !this.mobileMigrationDoneThisSession
                                         && this.configSystemService.getValue(ConfigSystemParams.TopBarShowMobileMigration, "OFF", true)=="ON"
                                         && (this.curUser.systemAdmin || this.curUser.systemAdminStd)                                         ; }

  get showAddCompanySimUserTools () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowAddCompanySimUser,                   false)    ; }  
  get showCompanyForUser         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowCompanyForUser,                      false) &&
                                             !this.componentAccessUserService.hasAccessGuid(AccessGuids.TopbarShowCompanyForUserGuard,                    true )    ; }
  get showSupportPage            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SupportPlansEnabled,                           false) &&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.FormSupportPage,                                   true )    ; }
  get showTemplateMenuItems      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTemplateMenuItems,                         false)    ; }
  get showTooltips               () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips,                                  false)    ; }
  get supportTicketIconUseMan    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarQuickLinksTicketIconSupportMan,          false)    ; }
  get supportTicketLockCompany   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarQuickLinksTicketLockCompanyWhenTracking, false)    ; }
  get testMode                   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemTestMode,                                false)    ; }
  get topBarShowAnimations       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowAnimations,                          false)    ; }
  get topBarShowApps             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowApps,                                false)    ; }
  get topBarShowCart             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowCart,                                false)    ; }
  get topBarShowChatGpt          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowChatGpt,                             false) &&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.TopBarShowChatGpt,                                 true )    ; }
  get topBarShowClock            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowClock,                               false)    ; }
  get topBarShowDarkMode         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowDarkMode,                            false)    ; }
  get topBarShowDownloads        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowDownloads,                           false)    ; }
  get topBarShowFullScreen       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowFullScreen,                          true )    ; }
  get topBarShowHamburger        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowHamburger,                           true )    ; }
  get topBarShowLanguage         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowLanguage,                            false)    ; }
  get topBarShowMenuItems        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowMenuItems,                           false)    ; }
  get topBarShowNotifications    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowNotifications,                       false)    ; }
  get topBarShowSearch           () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowSearch,                              false)    ; }
  get topBarShowSsoLoginIcon     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowSsoLoginIcon,                        false) &&
                                             DecryptAesClientSide(this.storageService.getItem(StorageValues.encSsoLoggedIn)                                    )    ; }
  get topBarShowSureSimSearch    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowSureSimSearch,                       false)    ; }
  get topBarShowTimeline         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowTimeline,                            false)    ; }
  get topBarShowUploads          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.TopBarShowUploads,                             false)    ; }
  
  private _progressInformationShow : boolean=false;
  private assistantFeaturesLoaded  : boolean=false;
  private assistantRestoreDone     : boolean=false;
  private assistantViewReady       : boolean=false;
  private clockBarDismissedSub     : Subscription | undefined;
  private clockBarHeight           : number=0;
  private companyModalFormIsOpen   : boolean=false;
  private element                  : any;
  private exceptionNotificationSub : Subscription | undefined;
  private notifyId                 : any;
  private provisionEsimFormIsOpen  : boolean=false;
  private ticketModalFormIsOpen    : boolean=false;
  private ticketNoteModalFormIsOpen: boolean=false;
  private totalNotify              : number=0;
  private userModalFormIsOpen      : boolean=false;

  public aiInitialInviewCompanyId      : number | undefined;
  public allnotifications              : any;
  public alertColourProgress           : string=AlertClassColour.Grey;
  public cart_length                   : any=0;
  public cartData!                     : CartModel[];
  public clockBarDismissed             : boolean=true;
  public topbarIconsCollapsed          : boolean=false;
  public cookieValue                   : any;
  public curUser                       : SystemUserDTO;
  public demoMode                      : 'standard' | 'demo'='standard';
  public featureEnabledChatGpt         : boolean=false;
  public flagvalue                     : any;
  public inviewCompanyId               : number | undefined;
  public isFullscreen                  : boolean=false;
  public isPlatformMode                : boolean=environment.platformMode;
  public isPlatformModeInview          : boolean=environment.platformModeInview;
  public logoutText                    : string | undefined;
  public messages                      : any;
  public mobileMigrationDoneThisSession: boolean=false;
  public mobileMigrationRunning        : boolean=false;
  public ourCompanyName                : string =this.platformInviewService.getOurCompanyName();
  public progressInformation           : string ="";
  public progressInformationType       : string =TypeProgressInformation.Information;
  public ssoLoggedIn                   : boolean=false;
  public sureSimCompanyId              : number | undefined;
  public total                         : number=0;
  public valueset                      : any;

  constructor(
    @Inject(DOCUMENT)
    private document                       : any,
    private authenticationService          : AuthenticationService,
    private autoLogoutService              : AutoLogoutService,
    private chatGptService                 : ChatGptService,
    private clockService                   : ClockService,
    private companiesService               : CompaniesService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private cookiesService                 : CookieService,
    private devicesService                 : DevicesService,
    private dropdownService                : DropdownService,
    private eventService                   : EventService,
    private exceptionsService              : ExceptionsService,
    private languageService                : LanguageService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private modalService                   : NgbModal,
    private ordersService                  : OrdersService,
    private router                         : Router,
    private storageService                 : StorageService,
    private topBarService                  : TopBarService,
    private usersService                   : UsersService,
    
    public platformInviewService: PlatformInviewService
  ) {
    this.curUser=this.authenticationService.currentUserObject();

    this.topBarService.inviewCompanyId$
    .subscribe(id => {
                 this.inviewCompanyId=id;
              });

    this.topBarService.sureSimCompanyId$
    .subscribe(id => {
                 this.sureSimCompanyId=id;
              });
  }

  public async ngOnInit(): Promise<void> {
    try {
      await this.enableFeatures();

      this.assistantFeaturesLoaded=true;
      this.restoreAssistantIfAllowed();

      this.ssoLoggedIn=DecryptAesClientSide(this.storageService.getItem(StorageValues.encSsoLoggedIn)) != null;
      this.logoutText =this.ssoLoggedIn ? `Logout of ${this.ourCompanyName}` : "Logout";
      this.element    =document.documentElement;
      this.cookieValue=this.cookiesService.get(CookieKeys.Language);
      const val       =this.listLang.filter(x => x.lang===this.cookieValue);
  
      if (val.length === 0) {
        if (this.flagvalue === undefined) {
          this.valueset = 'assets/images/flags/us.svg';
        }
      } else {
        this.flagvalue = val.map(element => element.flag);
      }
      
      this.allnotifications=allNotification;
      this.messages        =messages;
      this.cartData        =cartData;
      this.cart_length     =this.cartData.length;
  
      this.cartData.forEach((item) => {
        var item_price = item.quantity * item.price
        this.total += item_price
      });

      this.exceptionNotificationSub=this.exceptionsService.exceptionNotification$
        .subscribe((error) => {
          this.exceptionNotification(error);
        });

      this.clockBarDismissed=this.clockService.loadBarDismissed(this.curUser);
      this.clockService.ensureStarted(this.curUser);

      this.clockBarDismissedSub=this.clockService.barDismissedChanges$
        .subscribe(dismissed => {
          this.clockBarDismissed=dismissed;

          if (dismissed)
            this.clockBarHeight=0;

          this.updateTopbarTotalHeight();
        });

      this.loadDemoMode();

      this.queueProgressInfoHeightUpdate();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.queueProgressInfoHeightUpdate();
      this.updateTopbarTotalHeight();

      this.assistantViewReady=true;
      this.restoreAssistantIfAllowed();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private restoreAssistantIfAllowed(): void {
    try {
      if (this.assistantRestoreDone || !this.assistantFeaturesLoaded || !this.assistantViewReady)
        return;

      this.assistantRestoreDone=true;

      if (!this.showAssistant)
        return;

      Promise.resolve().then(() => this.chatGptModalForm?.restoreIfPreviouslyOpenAndDocked());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateTopbarTotalHeight(): void {
    try {
      if (this.topbarIconsCollapsed) {
        const clockHeight          =(this.topBarShowClock && !this.clockBarDismissed) ? this.clockBarHeight : 0;
        const progressHeight       =this._progressInformationShow && this.progressInfoRow?.nativeElement
                                    ? this.progressInfoRow.nativeElement.offsetHeight : 0;
        const collapsedNavbarHeight=20;
        const total                =clockHeight+collapsedNavbarHeight+progressHeight;

        if (total>0)
          this.document?.documentElement?.style?.setProperty('--ss-topbar-total-height', `${total}px`);
      } else {
        const el=document.getElementById('page-topbar');

        if (el && el.offsetHeight>0) {
          this.document?.documentElement?.style?.setProperty('--ss-topbar-total-height', `${el.offsetHeight}px`);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.clockBarDismissedSub?.unsubscribe();
      this.exceptionNotificationSub?.unsubscribe();
      this.setProgressInfoHeight(0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onClockBarHeightChanged(height: number): void {
    try {
      this.clockBarHeight=height;
      this.updateTopbarTotalHeight();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Clock

  public dismissClockBar(): void {
    try {
      this.clockService.setBarDismissed(this.curUser, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleTopbarIcons(): void {
    try {
      this.tooltipToggleBtn?.close();
      this.topbarIconsCollapsed=!this.topbarIconsCollapsed;
      setTimeout(() => requestAnimationFrame(() => this.updateTopbarTotalHeight()));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Demo Mode

  private demoModeStorageKey(): string {
    try {
      return `${StorageValues.encDemoMode_}${this.curUser?.userId ?? -1}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return `${StorageValues.encDemoMode_}-1`;
    }
  }

  private loadDemoMode(): void {
    try {
      const raw=DecryptAesClientSide(localStorage.getItem(this.demoModeStorageKey()));

      this.demoMode=(raw==='demo') ? 'demo' : 'standard';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setDemoMode(value: 'standard' | 'demo'): void {
    try {
      this.demoMode=value;
      localStorage.setItem(this.demoModeStorageKey(), EncryptAesClientSide(value));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Features
  
  public async enableFeatures(): Promise<void> {
    try {
      await this.enableFeatureChatGpt();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public async enableFeatureChatGpt(): Promise<void> {
    try {
      const data=await firstValueFrom(this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.curUser?.companyId ?? -1, AccessGuids.ChargeableFeatureChatGpt)
                       .pipe(
                         catchError((error) => {
                           return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                         })
                       )
    );

    this.featureEnabledChatGpt=data.result;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public designation(): string {
    try {
      return `${this.curUser.firstname} ${this.curUser.lastname} ${this.showCompanyForUser ? " - " + this.curUser.companyName: ""}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "Unknown Designation";
    }
  }

  public toggleMobileMenu(event: any) {
    try {
      document.querySelector('.hamburger-icon')?.classList.toggle('open')
      event.preventDefault();
      this.mobileMenuButtonClicked.emit(); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Fullscreen

  public fullscreen() {
    try {
      this.tooltipFullscreen.close();

      document.body.classList.toggle('fullscreen-enable');
      this.isFullscreen=!this.isFullscreen;

      if (!document.fullscreenElement &&
          !this.element.mozFullScreenElement &&
          !this.element.webkitFullscreenElement) {

        if (this.element.requestFullscreen) {
          this.element.requestFullscreen();
        } else if (this.element.mozRequestFullScreen) {
          /* Firefox */
          this.element.mozRequestFullScreen();
        } else if (this.element.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          this.element.webkitRequestFullscreen();
        } else if (this.element.msRequestFullscreen) {
          /* IE/Edge */
          this.element.msRequestFullscreen();
        }

      } else {
        
        if (this.document.exitFullscreen) {
          this.document.exitFullscreen();
        } else if (this.document.mozCancelFullScreen) {
          /* Firefox */
          this.document.mozCancelFullScreen();
        } else if (this.document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          this.document.webkitExitFullscreen();
        } else if (this.document.msExitFullscreen) {
          /* IE/Edge */
          this.document.msExitFullscreen();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public fullscreenIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipFullscreen);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  public openModal(content: any) {
    try {
    // this.submitted=false;
    this.modalService.open(content, { centered: true });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public changeMode(mode: string) {
    try {
      this.eventService.broadcast('changeMode', mode);
  
      switch (mode) {
        case 'light':
          document.documentElement.setAttribute('data-bs-theme', "light");
          break;
        case 'dark':
          document.documentElement.setAttribute('data-bs-theme', "dark");
          break;
        default:
          document.documentElement.setAttribute('data-bs-theme', "light");
          break;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
    { text: 'Española', flag: 'assets/images/flags/spain.svg', lang: 'es' },
    { text: 'Deutsche', flag: 'assets/images/flags/germany.svg', lang: 'de' },
    { text: 'Italiana', flag: 'assets/images/flags/italy.svg', lang: 'it' },
    { text: 'русский', flag: 'assets/images/flags/russia.svg', lang: 'ru' },
    { text: '中国人', flag: 'assets/images/flags/china.svg', lang: 'ch' },
    { text: 'français', flag: 'assets/images/flags/french.svg', lang: 'fr' },
    { text: 'Arabic', flag: 'assets/images/flags/ar.svg', lang: 'ar' },
  ];

  public setLanguage(text: string, lang: string, flag: string) {
    try {
      this.flagvalue  =flag;
      this.cookieValue=lang;
      this.languageService.setLanguage(lang);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public startLogOut(ssoLogout: boolean) {
    try {
      this.authenticationService.logoutApi()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        }),
        finalize(() => {
          this.logOut(ssoLogout);
        })
      )
      .subscribe({
        next: data => {
          
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }})
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      this.logOut(ssoLogout);
    }
  }

  public logOut(ssoLogout: boolean) {
    try {
      this.authenticationService.logout();

      if (ssoLogout) {
        this.authenticationService.logoutWithTenant(DecryptAesClientSide(this.storageService.getItem(StorageValues.encSsoTenantId)) ?? undefined, environment.sureSimClientId_Microsoft);
      } else {
        this.router.navigate(['/auth/login']);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public lockScreen() {
    try {
      this.autoLogoutService.stop();
      this.storageService.setItem(StorageValues.encLockRoute, EncryptAesClientSide(this.router.url));
      this.router.navigate(['/auth/lockscreen/basic']);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public windowScroll() {
    try {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        (document.getElementById("back-to-top") as HTMLElement).style.display = "block";
         document.getElementById('page-topbar')?.classList.add('topbar-shadow');
      } else {
        (document.getElementById("back-to-top") as HTMLElement).style.display = "none";
         document.getElementById('page-topbar')?.classList.remove('topbar-shadow');
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deleteItem(event: any, id: any) {
    try {
      var price       =event.target.closest('.dropdown-item').querySelector('.item_price').innerHTML;
      var Total_price =this.total - price;
      this.total      =Total_price;
      this.cart_length=this.cart_length - 1;
      this.total > 1 ? (document.getElementById("empty-cart") as HTMLElement).style.display = "none" : (document.getElementById("empty-cart") as HTMLElement).style.display = "block";
      document.getElementById('item_' + id)?.remove();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public search() {
    try {
      var searchOptions=document.getElementById("search-close-options") as HTMLAreaElement;
      var dropdown     =document.getElementById("search-dropdown") as HTMLAreaElement;

      var input: any, filter: any, ul: any, li: any, a: any | undefined, i: any, txtValue: any;
      input =document.getElementById("search-options") as HTMLAreaElement;
      filter=input.value.toUpperCase();

      if (filter.length > 0) {
        dropdown.classList.add("show");
        searchOptions.classList.remove("d-none");

        var inputVal  =input.value.toUpperCase();
        var notifyItem=document.getElementsByClassName("notify-item");
  
        Array.from(notifyItem).forEach(function (element: any) {
          var notifiTxt = ''

          if (element.querySelector("h6")) {
            var spantext=element.getElementsByTagName("span")[0].innerText.toLowerCase()
            var name    =element.querySelector("h6").innerText.toLowerCase()

            if (name.includes(inputVal)) {
              notifiTxt=name
            } else {
              notifiTxt=spantext
            }
          } else if (element.getElementsByTagName("span")) {
            notifiTxt=element.getElementsByTagName("span")[0].innerText.toLowerCase()
          }
          if (notifiTxt)
            element.style.display=notifiTxt.includes(inputVal) ? "block" : "none";
  
        });
      } else {
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeBtn() {
    try {
      var searchOptions       =document.getElementById("search-close-options") as HTMLAreaElement;
      var dropdown            =document.getElementById("search-dropdown") as HTMLAreaElement;
      var searchInputReponsive=document.getElementById("search-options") as HTMLInputElement;

      dropdown.classList.remove("show");
      searchOptions.classList.add("d-none");
      searchInputReponsive.value="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  checkedValGet: any[] = [];
  public onCheckboxChange(event: any, id: any) {
    try {
      this.notifyId = id
      var result;

      if (id == '1') {
        var checkedVal: any[] = [];

        for (var i = 0; i < this.allnotifications.length; i++) {
          if (this.allnotifications[i].state == true) {
            result = this.allnotifications[i].id;
            checkedVal.push(result);
          }
        }

        this.checkedValGet = checkedVal;
      } else {
        var checkedVal: any[] = [];
        for (var i = 0; i < this.messages.length; i++) {
          if (this.messages[i].state == true) {
            result = this.messages[i].id;
            checkedVal.push(result);
          }
        }
        this.checkedValGet = checkedVal;
      }
      checkedVal.length > 0 ? (document.getElementById("notification-actions") as HTMLElement).style.display = 'block' : (document.getElementById("notification-actions") as HTMLElement).style.display = 'none';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public notificationDelete() {
    try {
      if (this.notifyId == '1') {
        for (var i = 0; i < this.checkedValGet.length; i++) {
          for (var j = 0; j < this.allnotifications.length; j++) {
            if (this.allnotifications[j].id == this.checkedValGet[i]) {
              this.allnotifications.splice(j, 1)
            }
          }
        }
      } else {
        for (var i = 0; i < this.checkedValGet.length; i++) {
          for (var j = 0; j < this.messages.length; j++) {
            if (this.messages[j].id == this.checkedValGet[i]) {
              this.messages.splice(j, 1)
            }
          }
        }
      }
      this.calculatenotification()
      this.modalService.dismissAll();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private calculatenotification() {
    try {
      this.totalNotify = 0;
      this.checkedValGet = []
  
      this.checkedValGet.length > 0 ? (document.getElementById("notification-actions") as HTMLElement).style.display = 'block' : (document.getElementById("notification-actions") as HTMLElement).style.display = 'none';
      if (this.totalNotify == 0) {
        document.querySelector('.empty-notification-elem')?.classList.remove('d-none')
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Example Images

  public imageIconClick() {
    try {
      this.imageModalForm.openForm("Animations");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region ChatGPT

  public chatGptIconClick() {
    try {
      this.chatGptModalForm.openForm();
      this.tooltipChatGpt.disableTooltip=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public chatGptIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipChatGpt);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onAssistantActionRequested(action: ChatGptAction) {
    try {
      switch (action.type) {
        case 'open_modal':
          if (!this.canExecuteAssistantModalAction(action.modal)) {
            this.exceptionNotification(new Error(`You do not have access to '${action.modal}' actions.`));
            return;
          }

          this.chatGptService.appendAudit('open_modal_requested', this.curUser?.userId);
          this.executeAssistantModalAction(action.modal, {
            ...(action.payload ?? {}),
            label: action.label
          });
          break;
        default:
          this.exceptionNotification(new Error(`Unsupported assistant action '${action.type}'`));
          break;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private executeAssistantModalAction(modal: ChatGptModalTarget, payload: any) {
    try {
      this.chatGptService.executeModalAction(
        modal,
        payload,
        {
          company    : p  => this.openAssistantCompanyModal(p),
          download   : () => this.downloadCentreIconClick(),
          manage_sim : p  => this.openAssistantManageSimModal(p),
          provision  : p  => this.openAssistantProvisionModal(p),
          ticket     : p  => this.openAssistantTicketModal(p),
          timeline   : p  => this.openAssistantTimelineModal(p),
          upload     : () => this.uploadCentreIconClick(),
          user_portal: p  => this.openAssistantUserModal(true, p),
          user_sim   : p  => this.openAssistantUserModal(false, p),
        },
        unknown => this.exceptionNotification(new Error(`Unknown assistant modal target '${unknown}'`))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantTicketModal(payload: any) {
    try {
      const initialTicketId=this.extractAssistantTicketId(payload);

      if (initialTicketId > 0) {
        this.openAssistantTicketViewById(initialTicketId, payload);
        return;
      }

      if (this.ticketModalFormIsOpen)
        return;

      const initialCompanyId=this.toPositiveNumberOrDefault(payload?.companyId, -1);
      const companyName     =typeof payload?.companyName==='string' ? payload.companyName.trim() : "";
      const initialUserId   =this.toPositiveNumberOrDefault(payload?.userId, -1);
      const userName        =typeof payload?.userName==='string' ? payload.userName.trim() : "";
      const initialDeviceId =this.toPositiveNumberOrDefault(payload?.deviceId, -1);

      this.ticketModalFormIsOpen=true;

      forkJoin({
        companies: this.companiesService.getForLoggedInUser(this.curUser.userId),
        users    : initialUserId>0 || userName.length===0
                   ? of([] as UserDTO[])
                   : this.usersService.getUsersPortal(this.getAssistantUserSearchCompanyId(initialCompanyId))
      })
      .pipe(
        catchError((error) => {
          this.ticketModalFormIsOpen=false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
        .subscribe({
        next: ({ companies, users }) => {
          const matchedCompanyId=this.chatGptService.resolveCompanyId(companies, initialCompanyId, companyName);
          const matchedUser     =this.chatGptService.resolveUserByName(users, userName);
          const finalUserId     =initialUserId>0 ? initialUserId : (matchedUser?.id ? Number(matchedUser.id) : -1);
          const companyId       =matchedCompanyId>0
                                 ? matchedCompanyId
                                 : (this.supportTicketLockCompany && this.dropdownService.trackingCompanyIdIsOn() ? this.sureSimCompanyId ?? -1 : -1);

          this.ticketModalForm.openForm(companies, false, false, false, false, companyId, finalUserId, initialDeviceId);
        },
        error: error => {
          this.ticketModalFormIsOpen=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantTicketViewById(ticketId: number, payload: any) {
    try {
      if (this.ticketNoteModalFormIsOpen)
        return;

      const knownTicket=this.extractKnownAssistantTicket(payload, ticketId);

      if (!knownTicket) {
        this.router.navigate(['/support/ticket-hub'], { queryParams: { ticket: ticketId } });
        this.exceptionNotification(new Error(`Ticket #${ticketId} could not be opened directly. Opened Ticket Hub filtered by that ticket.`));
        return;
      }

      this.ticketNoteModalFormIsOpen=true;
      this.ticketNotesModalForm.openForm(knownTicket);
    }
    catch(e) {
      this.ticketNoteModalFormIsOpen=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private extractKnownAssistantTicket(payload: any, fallbackTicketId: number): Ticket | undefined {
    try {
      const source=payload?.ticket;
  
      if (!source || typeof source !== 'object')
        return undefined;
  
      const ticket    =source as Ticket;
      const resolvedId=Number((ticket as any)?.id ?? fallbackTicketId);
      const companyId =Number((ticket as any)?.company_id ?? payload?.companyId ?? 0);
  
      if (!Number.isFinite(resolvedId) || resolvedId <= 0)
        return undefined;
      
      if (!Number.isFinite(companyId) || companyId <= 0)
        return undefined;
  
      return {
        active             : true,
        affectedUser       : (ticket as any)?.affectedUser ?? '',
        affectedUserId     : Number((ticket as any)?.affectedUserId ?? payload?.userId ?? 0),
        company            : (ticket as any)?.company ?? '',
        company_id         : companyId,
        details            : (ticket as any)?.details ?? '',
        enteredBy          : Number((ticket as any)?.enteredBy ?? this.curUser?.userId ?? 0),
        enteredDate        : (ticket as any)?.enteredDate ? new Date((ticket as any).enteredDate) : new Date(),
        fullName           : (ticket as any)?.fullName ?? '',
        highPriority       : Boolean((ticket as any)?.highPriority),
        iccid              : (ticket as any)?.iccid ?? '',
        id                 : resolvedId,
        orderId            : Number((ticket as any)?.orderId ?? 0),
        priority           : (ticket as any)?.priority ?? '',
        priorityId         : Number((ticket as any)?.priorityId ?? 0),
        requester          : (ticket as any)?.requester ?? '',
        status             : (ticket as any)?.status ?? (payload?.entityStatus ?? '').toString(),
        testTicket         : false,
        ticketIssueKey     : (ticket as any)?.ticketIssueKey ?? '',
        ticketIssueTypeID  : Number((ticket as any)?.ticketIssueTypeID ?? 0),
        title              : (ticket as any)?.title ?? (payload?.ticketTitle ?? '').toString(),
        type               : (ticket as any)?.type ?? '',
        update_description : false,
        update_highPriority: false,
        userId             : Number((ticket as any)?.userId ?? payload?.userId ?? 0),
        username           : (ticket as any)?.username ?? '',
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private openAssistantProvisionModal(payload: any) {
    try {
      if (this.provisionEsimFormIsOpen)
        return;

      const iccid       =typeof payload?.iccid === 'string' ? payload.iccid : "";
      const deviceTypeId=Number.isFinite(Number(payload?.deviceTypeId)) ? Number(payload?.deviceTypeId) : -1;
      const companyId   =this.toPositiveNumberOrDefault(payload?.companyId, <number>this.inviewCompanyId);

      this.provisionEsimFormIsOpen=true;
      this.provisionModalForm.openForm(iccid, deviceTypeId, companyId, false, true, 0, 0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantUserModal(isPortal: boolean, payload: any) {
    try {
      if (this.userModalFormIsOpen) {
        this.exceptionNotification(new Error("User form is already open"));
        return;
      }

      const userId                 =this.toPositiveNumberOrDefault(payload?.userId, -1);
      const userName               =typeof payload?.userName === 'string' ? payload.userName.trim() : "";
      const aiCompanyId            =this.toPositiveNumberOrDefault(payload?.companyId, -1);
      this.aiInitialInviewCompanyId=aiCompanyId > 0 ? aiCompanyId : undefined;

      if (userId>0) {
        this.userModalFormIsOpen=true;
        this.userModalForm.openForm(userId, isPortal ? eUser.portal : eUser.sim);
        return;
      }

      if (userName.length>0) {
        this.openAssistantUserModalByName(isPortal, userName, aiCompanyId);
      } else {
        if (isPortal) {
          this.addUserPortalIconClick();

        } else {
          this.addUserSimIconClick();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantUserModalByName(isPortal: boolean, userName: string, fallbackCompanyId: number) {
    try {
      const searchCompanyId=this.getAssistantUserSearchCompanyId(fallbackCompanyId);
      const dataSource     =isPortal
                            ? this.usersService.getUsersPortal(searchCompanyId)
                            : this.usersService.getUsersESim(searchCompanyId);

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const matchedUser=this.chatGptService.resolveUserByName(data, userName);

          if (matchedUser?.id && Number(matchedUser.id) > 0) {
            this.aiInitialInviewCompanyId=undefined;
            this.userModalFormIsOpen     =true;
            this.userModalForm.openForm(Number(matchedUser.id), isPortal ? eUser.portal : eUser.sim);
          } else {
            const destination=isPortal ? '/users/users-portal' : '/users/users-esim';
            this.router.navigate([destination], { queryParams: { user: userName } });
            this.exceptionNotification(new Error(`User '${userName}' was not found. Opened Users grid with filter instead.`));
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantCompanyModal(payload: any) {
    try {
      if (this.companyModalFormIsOpen) {
        this.exceptionNotification(new Error("Company form is already open"));
        return;
      }

      const companyId  =this.toPositiveNumberOrDefault(payload?.companyId, -1);
      const companyName=typeof payload?.companyName==='string' ? payload.companyName.trim() : "";

      if (companyId>0) {
        this.companyModalFormIsOpen=true;
        this.companyModalForm.openForm(companyId);
        return;
      }

      if (companyName.length>0) {
        this.companiesService.getIdByCompanyName(companyName)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            const matchedCompanyId=this.toPositiveNumberOrDefault(data?.result, -1);

            if (matchedCompanyId>0) {
              this.openCompanyFormById(matchedCompanyId);

            } else {
              this.openAssistantCompanyModalByListMatch(companyName);
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
            this.openAssistantCompanyModalByListMatch(companyName);
          }
        });
        return;
      }

      this.companyModalFormIsOpen=true;
      this.companyModalForm.openForm(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantCompanyModalByListMatch(companyName: string) {
    try {
      this.companiesService.getForLoggedInUser(this.curUser.userId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const matchedCompanyId=this.chatGptService.resolveCompanyId(data, -1, companyName);

          if (matchedCompanyId>0) {
            this.openCompanyFormById(matchedCompanyId);

          } else {
            this.router.navigate(['/companies/companies'], { queryParams: { company: companyName } });
            this.exceptionNotification(new Error(`Company '${companyName}' was not found. Opened Companies grid with filter instead.`));
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openCompanyFormById(companyId: number) {
    try {
      this.companyModalFormIsOpen=true;
      this.companyModalForm.openForm(companyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantTimelineModal(payload: any) {
    try {
      const iccid=typeof payload?.iccid==='string' && payload.iccid.trim().length>0 ? payload.iccid.trim() : undefined;
      this.timelineModalForm.openForm(iccid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantManageSimModal(payload: any) {
    try {
      const iccid=typeof payload?.iccid==='string' ? payload.iccid.trim() : '';

      if (!iccid) {
        this.navigateAssistantSimGrid();
        this.exceptionNotification(new Error('SIM ICCID was missing. Opened Allocated SIMs grid instead.'));
        return;
      }

      if (!this.isLikelyIccidValue(iccid)) {
        this.resolveAssistantSimIccidFromPayload(iccid, payload);
        return;
      }

      this.openAssistantManageSimByIccid(iccid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openAssistantManageSimByIccid(iccid: string) {
    try {
      this.ordersService.getOrderIdByIccid(iccid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const orderId=this.toPositiveNumberOrDefault(data?.result, -1);
  
          if (orderId>0) {
            this.manageEsimModalForm.openForm(orderId);
  
          } else {
            this.navigateAssistantSimGrid(iccid, true);
            this.exceptionNotification(new Error(`SIM '${iccid}' could not be opened directly. Opened SIM grid filtered by ICCID.`));
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resolveAssistantSimIccidFromPayload(searchText: string, payload: any) {
    try {
      const candidateUserId   =this.toPositiveNumberOrDefault(payload?.userId, -1);
      const candidatesForUser$=candidateUserId>0
                               ? this.devicesService.getIdAndDescriptionForUser(candidateUserId).pipe(
                                   catchError(() => of([] as IdAndDescriptionDTO[]))
                                 )
                               : of([] as IdAndDescriptionDTO[]);

      candidatesForUser$
      .pipe(
        map(candidates => this.pickAssistantSimIccid(candidates, searchText)),
        switchMap(resolved => resolved ? of(resolved) : this.resolveAssistantSimIccidViaUserName$(searchText, payload))
      )
      .subscribe({
        next: resolved => {
          if (resolved) {
            this.openAssistantManageSimByIccid(resolved);

          } else {
            this.navigateAssistantSimGrid(searchText, true);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      this.navigateAssistantSimGrid(searchText);
    }
  }

  private resolveAssistantSimIccidViaUserName$(searchText: string, payload: any) {
    try {
      const userName=typeof payload?.userName==='string' ? payload.userName.trim() : '';
  
      if (!userName)
        return of(undefined as string | undefined);
  
      const preferredCompanyId=this.toPositiveNumberOrDefault(payload?.companyId, -1);
      const searchCompanyId   =this.getAssistantUserSearchCompanyId(preferredCompanyId);
  
      return this.usersService.getUsersESim(searchCompanyId).pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        }),
        map(users => this.chatGptService.resolveUserByName(users, userName)),
        map(matchedUser => this.toPositiveNumberOrDefault(matchedUser?.id, -1)),
        switchMap(matchedUserId => {
          if (matchedUserId<=0)
            return of(undefined as string | undefined);
          
          return this.devicesService.getIdAndDescriptionForUser(matchedUserId).pipe(
            catchError(() => of([] as IdAndDescriptionDTO[])),
            map(candidates => this.pickAssistantSimIccid(candidates, searchText))
          );
        })
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private navigateAssistantSimGrid(searchText?: string, openForm: boolean=false): void {
    try {
      const queryParams: any={};
  
      const sim=(searchText ?? '').trim();
  
      if (sim.length>0)
        queryParams.sim=sim;
      
      if (openForm)
        queryParams.openForm=1;
      
      if (Object.keys(queryParams).length===0) {
        this.router.navigate(['/provisioning/devices-allocated']);
        return;
      }
  
      this.router.navigate(['/provisioning/devices-allocated'], { queryParams });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private pickAssistantSimIccid(candidates: IdAndDescriptionDTO[], searchText: string): string | undefined {
    try {
      const values=(candidates ?? [])
                   .map(x => (x?.description ?? '').toString().trim())
                   .filter(x => this.isLikelyIccidValue(x));
  
      if (values.length===1)
        return values[0];
  
      const normalized=(searchText ?? '').trim().toLowerCase();
  
      if (normalized.length>0) {
        const contains=values.find(v => v.toLowerCase().includes(normalized));
  
        if (contains)
          return contains;
      }
  
      return values[0];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private isLikelyIccidValue(value: string): boolean {
    try {
      const normalized=(value ?? '').replace(/\s+/g, '');
      return /^\d{10,22}$/.test(normalized);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private toPositiveNumberOrDefault(value: any, fallback: number): number {
    try {
      const parsed=Number(value);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return fallback;
    }
  }

  private extractAssistantTicketId(payload: any): number {
    try {
      const direct=this.toPositiveNumberOrDefault(payload?.ticketId, -1);
  
      if (direct > 0)
        return direct;
  
      const candidates=[
        payload?.ticketId?.toString?.() ?? '',
        payload?.ticketTitle?.toString?.() ?? '',
        payload?.label?.toString?.() ?? '',
      ];
  
      for (const value of candidates) {
        const match=(value ?? '').match(/#?\s*(\d{2,})/);
        if (match?.[1]) {
          const parsed=Number(match[1]);
          if (Number.isFinite(parsed) && parsed > 0) {
            return parsed;
          }
        }
      }
  
      return -1;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return -1;
    }
  }

  private getAssistantUserSearchCompanyId(preferredCompanyId: number): number {
    try {
      if (preferredCompanyId > 0) {
        return preferredCompanyId;
      }
      const trackerCompanyId=Number(this.sureSimCompanyId ?? 0);
  
      if (Number.isFinite(trackerCompanyId) && trackerCompanyId>0)
        return trackerCompanyId;
      
      const curCompanyId=Number((this.curUser as any)?.companyId ?? (this.curUser as any)?.companyID ?? 0);
      return Number.isFinite(curCompanyId) && curCompanyId > 0 ? curCompanyId : 0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 0;
    }
  }

  private canExecuteAssistantModalAction(modal: ChatGptModalTarget): boolean {
    try {
      return this.chatGptService.canExecuteModalAction(modal);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#region Timeline

  public timelineIconClick() {
    try {
      this.timelineModalForm.openForm(undefined);
      this.tooltipTimeline.disableTooltip=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public timelineIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipTimeline);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Download Centre

  public downloadCentreIconClick() {
    try {
      this.downloadCentreForm.openForm();
      this.tooltipDownloads.disableTooltip=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public downloadCentreIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipDownloads);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SSO Login

  public ssoLoginIconClick() {
    try {
      this.tooltipSsoLogin.disableTooltip=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ssoLoginIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipSsoLogin);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Upload Centre

  public uploadCentreIconClick() {
    try {
      this.uploadCentreForm.openForm();
      this.tooltipUploads.disableTooltip=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public uploadCentreIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipUploads);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Add Company

  public addCompanyIconClick() {
    try {
      this.tooltipAddCompany.disableTooltip=true;
      
      if (!this.companyModalFormIsOpen) {
        this.companyModalFormIsOpen=true;

        this.companyModalForm.openForm(undefined);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addCompanyIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipAddCompany);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      this.companyModalFormIsOpen=false;

      this.topBarService.companyDataHasBeenSaved(sureSimCompanyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormHasBeenCancelled() {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Add User (Portal and SIM)

  //#region Add User Portal

  public addUserPortalIconClick() {
    try {
      this.tooltipAddUserPortal.disableTooltip=true;
      
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
      
        this.userModalForm.openForm(undefined, eUser.portal);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addUserPortalIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipAddUserPortal);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Add User SIM

  public addUserSimIconClick() {
    try {
      this.tooltipAddUserSim.disableTooltip=true;
      
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
      
        this.userModalForm.openForm(undefined, eUser.sim);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addUserSimIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipAddUserSim);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  public userDataHasBeenSaved(sureSimUserId: number | undefined) {
    try {
      this.userModalFormIsOpen     =false;
      this.aiInitialInviewCompanyId=undefined;
      
      this.topBarService.userDataHasBeenSaved(sureSimUserId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public userFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen     =false;
      this.aiInitialInviewCompanyId=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Add Support Ticket

  public addSupportTicketIconClick() {
    try {
      this.tooltipAddSupportTicket.disableTooltip=true;
      
      if (!this.ticketModalFormIsOpen) {
        this.ticketModalFormIsOpen=true;
      
        this.companiesService.getForLoggedInUser(this.curUser.userId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            const companyId: number=this.supportTicketLockCompany && this.dropdownService.trackingCompanyIdIsOn()
                                    ? this.sureSimCompanyId ?? -1
                                    : -1;

            this.ticketModalForm.openForm(data, false, false, false, false, companyId ?? -1, -1, -1);
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addSupportTicketIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipAddSupportTicket);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ticketFormHasBeenSaved() {
    try {
      this.ticketModalFormIsOpen=false;
      
      this.topBarService.supportTicketHasBeenSaved();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ticketFormHasBeenCancelled() {
    try {
      this.ticketModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ticketNoteFormHasBeenSaved() {
    try {
      this.ticketNoteModalFormIsOpen=false;
      this.topBarService.supportTicketHasBeenSaved();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ticketNoteFormHasBeenCancelled() {
    try {
      this.ticketNoteModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Add SIM

  public addSimIconClick() {
    try {
      if (!this.provisionEsimFormIsOpen) {
        this.provisionEsimFormIsOpen=true;
      
        this.provisionModalForm.openForm("", -1, <number>this.inviewCompanyId, false, true, 0, 0);
      }
      
      this.tooltipAddSim.disableTooltip=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addSimIconMouseEnter() {
    try {
      this.hideAllTooltips(this.tooltipAddSim);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public iccidHasBeenProvisioned() {
    try {
      this.provisionEsimFormIsOpen=false;
      
      this.topBarService.iccidHasBeenProvisioned();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public provisionESIMFormHasBeenCancelled() {
    try {
      this.provisionEsimFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Back to Platform

  public backToPlatformClick(): void {
    try {
      if (this.isPlatformModeInview) {
        this.platformInviewService.setMode('platform');
        this.router.navigate([this.dashboardUrl]);
      }
      else {
        this.router.navigate(['/platform']);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public hideAllTooltips(exceptForTooltip: NgbTooltip | undefined) {
    try {
      if (exceptForTooltip) {
        //CRN_20250417 - Disable
        
        if (this.tooltipAddCompany && this.tooltipAddCompany != exceptForTooltip) {
          this.tooltipAddCompany.disableTooltip=true;
          this.tooltipAddCompany.close();
        }
        
        if (this.tooltipAddSim && this.tooltipAddSim != exceptForTooltip) {
          this.tooltipAddSim.disableTooltip=true;
          this.tooltipAddSim.close();
        }
        
        if (this.tooltipAddSupportTicket && this.tooltipAddSupportTicket != exceptForTooltip) {
          this.tooltipAddSupportTicket.disableTooltip=true;
          this.tooltipAddSupportTicket.close();
        }
        
        if (this.tooltipAddUserPortal && this.tooltipAddUserPortal != exceptForTooltip) {
          this.tooltipAddUserPortal.disableTooltip=true;
          this.tooltipAddUserPortal.close();
        }
        
        if (this.tooltipAddUserSim && this.tooltipAddUserSim != exceptForTooltip) {
          this.tooltipAddUserSim.disableTooltip=true;
          this.tooltipAddUserSim.close();
        }
        
        if (this.tooltipChatGpt && this.tooltipChatGpt != exceptForTooltip) {
          this.tooltipChatGpt.disableTooltip=true;
          this.tooltipChatGpt.close();
        }
  
        if (this.tooltipDownloads && this.tooltipDownloads != exceptForTooltip) {
          this.tooltipDownloads.disableTooltip=true;
          this.tooltipDownloads.close();
        }
        
        if (this.tooltipFullscreen && this.tooltipFullscreen != exceptForTooltip) {
          this.tooltipFullscreen.disableTooltip=true;
          this.tooltipFullscreen.close();
        }
        
        if (this.tooltipSsoLogin && this.tooltipSsoLogin != exceptForTooltip) {
          this.tooltipSsoLogin.disableTooltip=true;
          this.tooltipSsoLogin.close();
        }
        
        if (this.tooltipTimeline && this.tooltipTimeline != exceptForTooltip) {
          this.tooltipTimeline.disableTooltip=true;
          this.tooltipTimeline.close();
        }
        
        if (this.tooltipUploads && this.tooltipUploads != exceptForTooltip) {
          this.tooltipUploads.disableTooltip=true;
          this.tooltipUploads.close();
        }
  
        //CRN_20250417 - Enable
        exceptForTooltip.disableTooltip=false;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Communications

  public openCommunication(communicationId: number) {
    try {
      this.communicationGridModalForm.openMessage(communicationId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public viewNotifications() {
    try {
      this.communicationGridModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region ProgressInformation

  public get progressInformationShow(              ): boolean { return this._progressInformationShow;                                      }
  public set progressInformationShow(value: boolean)          { this._progressInformationShow=value; this.queueProgressInfoHeightUpdate(); }

  private queueProgressInfoHeightUpdate() {
    try {
      setTimeout(() => this.updateProgressInfoHeight(), 0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateProgressInfoHeight() {
    try {
      const height=this._progressInformationShow && this.progressInfoRow?.nativeElement
                   ? this.progressInfoRow.nativeElement.offsetHeight
                   : 0;

      this.setProgressInfoHeight(height);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setProgressInfoHeight(height: number) {
    try {
      this.document?.documentElement?.style?.setProperty('--ss-topbar-progress-height', `${height}px`);
      this.updateTopbarTotalHeight();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public dismissProgressInformation() {
    try {
      this.progressInformationShow=false;
      this.progressInformationType=TypeProgressInformation.Information;
      this.alertColourProgress    =AlertClassColour.Grey;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Exception Notifications

  public exceptionNotification(error: Error) {
    try {
      this.alertColourProgress    =AlertClassColour.Red;
      this.progressInformation    =error?.message ?? "";
      this.progressInformationType=TypeProgressInformation.Error;
      this.progressInformationShow=this.progressInformation.trim().length > 0 && true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Testing - CRN_20260528 - Keep at bottom for ease finding

  //CRN_20260528 - Do not remove this method, it is used
  //               Ensure contents are commented out after use

  public testIconClick() {
    try {
      //CRN_20260528 - SQL Injection Test "' or (select @@version) > 1 --"
      //             - Example: this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.curUser.companyId, "' or (select @@version) > 1 --")

      // const x: EsimReservationDTO={
      //            deviceId        : 123,
      //            deviceTypeId    : 123,
      //            iccid           : "xxx",
      //            inviewCompanyId : 123,
      //            numberToReserve : 123,
      //            orderGuid       : "xxx",
      //          }

      //CRN_20260528 - Standard data call
      // this.webbingService.SetProduct("123456789", 12345)//, 123)//, <OurDate>populateOurDate(this.exceptionsService, "01/01/2050"), <OurDate>populateOurDate(this.exceptionsService, "01/01/2050"))//, 1324)//, 33333, 44444)//, undefined)
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     const _data=data;
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });

      //CRN_20260528 - BooleanResult
      // this.mdmDevicesIntuneService.sendAllMdmDeviceRemediationCommunications()//(new Date(2026, 4, 28))//(77, 251, [2,4,8,16])
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     const x=data.result;
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });

      //CRN_20260528 - IntegerResult
      //this.devicesService.totalLiveDevicesForCompany(77)
      // this.licencesCompanyAllocatedService.totalLivePlatformLicencesForCompany(77)
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     const x=data.result;
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public runMobileMigrationClick(): void {
    try {
      if (this.mobileMigrationRunning)
        return;

      Swal.fire({
        title             : "Run mobile number migration?",
        text              : "This normalises stored mobile numbers to international format. It runs once and may take a few minutes.",
        icon              : "question",
        showCancelButton  : true,
        confirmButtonText : "Run migration",
        cancelButtonText  : "Cancel",
        confirmButtonColor: "#299cdb"
      }).then((result) => {
        if (!result.isConfirmed)
          return;

        this.mobileMigrationRunning=true;

        Swal.fire({
          title            : "Running migration ...",
          allowOutsideClick: false,
          allowEscapeKey   : false,
          didOpen          : () => { Swal.showLoading(); }
        });

        this.usersService.runMobileNumberMigration()
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          }),
          finalize(() => { this.mobileMigrationRunning=false; })
        )
        .subscribe({
          next: (data) => {
            if (data?.result !== true) {
              Swal.close();
              this.exceptionsService.handleException(new Error("UsersService.runMobileNumberMigration() - The migration did not complete successfully"));
              return;
            }

            this.mobileMigrationDoneThisSession=true;

            Swal.fire({
              title            : "Migration complete",
              icon             : "success",
              timer            : 3000,
              timerProgressBar : true,
              showConfirmButton: false
            });
          },
          error: (error) => {
            Swal.close();
            this.exceptionsService.handleException(new Error(error));
          }
        });
      });
    }
    catch(e) {
      this.mobileMigrationRunning=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
